import { useEffect, useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Flex,
  Select,
  Text
} from "@theorgchartdev/storybook";
import { GetValuesForField } from "@/Utils/Promises";
import { commonSelectProps } from "../AuthorizationUtils";
import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import { FieldSelectListProps } from "@/Utils/ComponentLib";
import { appstr } from "@coreapp/utils/appstr";
import { enumAutoAssignmentFullAccess, autoAssignmentDisplayStrings } from "../AuthorizationUtils";

export const GroupAssignmentModal = ({ show, onClose, field, accessGroups, AddGroupMap }) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [fieldValues, setFieldValues] = useState([]);

  const GetFieldValues = async () => {
    const { results } = await GetValuesForField(field);
    setFieldValues(results);
  };

  useEffect(() => {
    GetFieldValues();
  }, []);

  const getFullAccessAndRoleOptions = () => {
    const clickHandler = e => setSelectedGroup(e.value);
    const options = Object.values(enumAutoAssignmentFullAccess);

    return options.map(option => {
      return {
        label: appstr(autoAssignmentDisplayStrings[option]),
        value: option,
        clickHandler,
        dataTestId: `auth-group-modal-mapsto-select-option-${option}`
      };
    });
  };

  if (!fieldValues) return;

  const BuildFieldValueOptions = () => {
    let options = [];
    for (const i in fieldValues) {
      const label = fieldValues[i];
      const valueContent = {
        label,
        value: label,
        clickHandler: e => setSelectedValue(e.value),
        dataTestId: `auth-group-modal-value-select-option-${label}`
      };

      options.push(valueContent);
    }
    return options;
  };

  const BuildGroupOptions = groups => {
    let options = [];
    for (const i in groups) {
      const label = groups[i].name;
      const groupContent = {
        label,
        value: i,
        clickHandler: e => setSelectedGroup(e.value),
        dataTestId: `auth-group-modal-mapsto-select-option-${label}`
      };

      options.push(groupContent);
    }
    options = options.concat(getFullAccessAndRoleOptions());
    return options;
  };

  return (
    <CentralizedModalContainer show={show}>
      <Modal
        show={show}
        centerOnScreen={true}
        fullScreen={false}
        customStyle={{ padding: 0, width: "640px" }}
      >
        <DialogTitle divider={true} onClose={() => onClose()}>
          {appstr("Configure group field mapping")}
        </DialogTitle>

        <DialogContent>
          <Flex direction={"column"} gap={"8px"} padding={"8px 0px 0px"}>
            <Text>{`${appstr("Field")}: ${field}`}</Text>
            <Flex direction={"row"} gap={"24px"}>
              <Select
                {...commonSelectProps}
                dataTestId="auth-group-modal-value-select"
                listProps={FieldSelectListProps()}
                label={`${appstr("Value")}:`}
                inputOnly={false}
                options={BuildFieldValueOptions()}
                value={selectedValue}
              />
              <Select
                {...commonSelectProps}
                dataTestId="auth-group-modal-mapsto-select"
                label={`${appstr("Maps to")}:`}
                inputOnly={false}
                options={BuildGroupOptions(accessGroups)}
                value={selectedGroup}
              />
            </Flex>
          </Flex>
        </DialogContent>

        <DialogActions divider={true}>
          <DialogActions.Tertiary onClick={() => onClose()}>
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary
            dataTestId="auth-group-modal-save-btn"
            disabled={selectedValue === null || selectedGroup === null}
            onClick={() => AddGroupMap(selectedValue, selectedGroup)}
          >
            {appstr("Save")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
